import { render, staticRenderFns } from "./CvCoverLetter.vue?vue&type=template&id=e2229f20&scoped=true"
import script from "./CvCoverLetter.vue?vue&type=script&lang=js"
export * from "./CvCoverLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2229f20",
  null
  
)

export default component.exports